import { createElement } from "react";
import { Navigate } from "react-router-dom";

import { createBrowserRouter } from "@datadog/browser-rum-react/react-router-v6";

import { Step, steps } from "./steps";
import { StepPath } from "./paths";
import { AppProvider } from "../providers";

export const router = createBrowserRouter([
  {
    path: "*",
    element: <AppProvider />,
    children: [
      ...steps.map((step: Step) => ({
        path: step.path,
        element: createElement(step.Component),
      })),
      {
        path: "*",
        element: <Navigate to={`/${StepPath.POLICY_DETAILS}`} />,
      },
    ],
  },
]);
